import { OnSchedRest }  from "../OnSchedRest";
import { OnSchedUtils } from "../utils";


export const GetLocation = (element, payload) => new Promise((resolve, reject) => {
  const { onsched } = element;

  let url = onsched.apiBaseUrl + '/locations?';

  if (payload.id) {
    url = onsched.apiBaseUrl + '/locations/' + payload.id;
  }
  else {
    Object.keys(payload).map(k => { url += `${k}=${payload[k]}&` });
  }
  
  OnSchedRest.Get(url, data => {
    OnSchedUtils.CheckErrors({ element, data })
      .then(() => {
        if (payload.id) {
          resolve(data);
        }
        else if (data.data?.length) {
          resolve(data.data[0]);
        }
        else {
          resolve(null)
        }
      })
  });
});

export const GetCountries = (element) => new Promise(resolve => {
  const countriesUrl = element.onsched.apiBaseUrl + '/customers/countries';

  OnSchedRest.Get(countriesUrl, resolve)
});

export const GetStates = (element, countryCode) => new Promise(resolve => {
  const statesUrl = element.onsched.apiBaseUrl + '/customers/states?country=' + countryCode;

  OnSchedRest.Get(statesUrl, resolve)
});

export const GetCountryStateCode = (element, { country, state }) => new Promise(resolve => {
  const countriesUrl = element.onsched.apiBaseUrl + '/customers/countries';

  OnSchedRest.Get(countriesUrl, countries => {
    const countryFound = countries.filter(c => c.name.toLowerCase().includes(country.toLowerCase()))[0];

    if (countryFound) {
      const statesUrl = element.onsched.apiBaseUrl + 'customers/states?country' + countryFound.code;

      OnSchedRest.Get(statesUrl, states => {
        const stateFound = states.filter(s => s.name.toLowerCase().includes(state.toLowerCase()))[0];

        if (stateFound) {
          resolve(stateFound);
        }
      })
    }
  })
});